import { z } from 'zod';
import { FeeHurdleBasis } from 'further-types/investment';
import isMongoId from '../../helpers/is-mongo-id';
import { GrossOrNetFee } from 'further-types/performance-fee';
import { withPaginationParamsOptional } from '../../helpers';

export const CreateOrEditPerformanceFeeTemplateInput = z.object({
  id: z
    .string()
    .refine(isMongoId({ optional: true }))
    .optional(),
  nameOnlyUpdate: z.boolean().optional(),
  firmId: z
    .string()
    .refine(isMongoId({ optional: true }))
    .optional(),
  feeTemplateName: z.string().min(1, 'Fee template name is required'),
  hurdleBasis: z.nativeEnum(FeeHurdleBasis, {
    message: 'Please select a valid hurdle basis',
  }),
  grossOrNetFees: z.nativeEnum(GrossOrNetFee, {
    message: 'Please select a valid option',
  }),
  excludeResidualCapitalFromHurdle: z.boolean().optional(),
  performanceFees: z.array(
    z.object({
      feeName: z
        .string({ message: 'Fee name is required' })
        .min(1, 'Fee name must be at least one character'),
      hurdle: z
        .number({
          message: 'Hurdle must be a valid number',
        })
        .min(0),
      feePercentageExVAT: z
        .number({
          message: 'Net fee must be greater than 0',
        })
        .min(0.01),
      feePercentageIncVAT: z
        .number({
          message: 'Gross fee must be greater than 0',
        })
        .min(0.01),
      vatPercentage: z.number().refine((val) => val === 0 || val === 20, {
        message: 'Please select VAT (must be 0 or 20)',
      }),
    }),
  ),
});

export const ListPerformanceFeeTemplatesInput = withPaginationParamsOptional(
  z.object({
    firmId: z
      .string()
      .refine(isMongoId({ optional: true }))
      .optional(),
    name: z.string().optional(),
    investmentId: z
      .string()
      .refine(isMongoId({ optional: true }))
      .optional(),
  }),
  ['createdAt'],
);

export const DeletePerformanceFeeTemplateInput = z.object({
  id: z.string().refine(isMongoId()),
});

export const GetPerformanceFeeTemplateByIdInput = z.object({
  id: z.string().refine(isMongoId()),
});
